import React from 'react'
import { Category } from '../components/categorymenu'

export class CheckinCheckoutPage extends React.Component {


    render() {
        return (
            <div>
                <Category />
                <div>CHECK IN / CHECK OUT</div>
            </div>
        )
    }
}